import { AccessLevelEnum } from "./SecurityTypes";

export const defaultCategoryFilter = {
  search: ""
}
export type CategoryFilterType = typeof defaultCategoryFilter

export interface ICategoryDetailedGet extends ICategoryGet {
  product?: IProductGet
}
export interface IProductGet {
  designation: string,
  description: string,
  code: string,
  name: string,
  release: string
}

export interface ICategoryGet {
  id: string;
  name: string;
  level: number;
  treePosition: string;
  productId?: string;
  parentId?: string;
  hasChildren?: boolean;
  accessLevel: AccessLevelEnum;
  correspondsToFilter: boolean;
  children?: Array<ICategoryGet>
}
